import Notice from "./Notice.vue";

export default {
    install: (Vue) => {
        const NoticeConstructor = Vue.extend(Notice)
        const noticeInstance = new NoticeConstructor();
        document.body.appendChild(noticeInstance.$mount().$el);
        Vue.prototype.$notice = noticeInstance.addNotice;
    }
}